/**
 * Created by Daniela on 27/01/2017.
 */
import { Component, OnInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {TanqueNavigationService} from "../shared/tanque-navigation.service";
import {
    tanquesEstoqueModuleName, tanquesModuleName, tanquesMovimentacaoModuleName,
    TiposMovimentacoesTanques
} from "../shared/data.service";
import {editRoute, newRouteFemale} from "../../../shared/services/data.service";
import {Tanque, MovimentacaoTanque, MovimentacaoTanqueArea} from "../shared/tanque.model";
import {Funcionario} from "../../../recursos-humanos/funcionarios/funcionario.model";
import {Area} from "../../../estruturas/areas/shared/area.model";
import {AreaApiService} from "../../../estruturas/areas/shared/area-api.service";
import {FuncionarioApiService} from "../../../recursos-humanos/funcionarios/funcionario-api.service";
import {TanqueApiService} from "../shared/tanque-api.service";
import {funcionariosQueryComPessoa} from "../../../recursos-humanos/funcionarios/data.service";
import {areasQuery} from "../../../estruturas/areas/shared/data.service";
import {UtilService} from "../../../shared/services/util.service";
import {TanqueService} from "../shared/tanque.service";
import {FuncionarioService} from "../../../recursos-humanos/funcionarios/funcionario.service";
import {TipoAjusteApiService} from "../../tipo-ajustes/shared/tipo-ajuste-api.service";
import {TipoAjuste} from "../../tipo-ajustes/shared/tipo-ajuste.model";
import {NumberValidator} from "../../../shared/validators/number.validation";
import {Bomba} from "../../bombas/shared/bomba.model";
import {BombaApiService} from "../../bombas/shared/bomba-api.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {abastecimentosModuleName} from "../../shared/data.service";

@Component({
    template: require('./tanque-movimentacao-form.component.html'),
    styles: [require('./tanque-movimentacao-form.component.css')]
})
export class TanqueMovimentacaoFormComponent implements OnInit, AfterViewChecked {
    tanquesModuelName: any = tanquesModuleName;
    tanquesEstoqueModuleName: any = tanquesEstoqueModuleName;
    tanquesMovimentacaoModuleName: any = tanquesMovimentacaoModuleName;
    actionTitle: string;
    formObject: any = new MovimentacaoTanque();
    tanqueObject: any = new Tanque();
    tanqueDestinoObject: any = new Tanque();
    funcionarioObject: any = new Funcionario();
    areaObject: any = new Area();
    tipoAjusteObject: any = new TipoAjuste();
    bombaObject: any = new Bomba();
    lancamentoObject: any = {};
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    showAreasMessage: boolean = false;
    module: any = abastecimentosModuleName;

    loadingSpinnerTanques: boolean = false;
    tanquesList: any[] = [];
    tanquesDestinoList: any[] = [];
    tipoLancamentosList: any[] = [];
    funcionarioSelectId: string = 'funcionarioSelect';
    funcionarioQuery: any = {};
    areaSelectId: string = 'areaSelect';
    areaQuery: any = {};
    loadingSpinnerTipoAjustes: boolean = false;
    tipoAjustesList: any[] = [];
    areasList: any[] = [];
    loadingSpinnerBombas: boolean = false;
    bombasList: any[] = [];

    form: FormGroup;
    ativo = new FormControl('');
    data = new FormControl('', Validators.required);
    quantidade = new FormControl('', Validators.compose([Validators.required, NumberValidator.numberFormat]));
    // odometroHorimetro = new FormControl('', Validators.required);
    tipoLancamento = new FormControl('', Validators.required);
    notaFiscal = new FormControl('', Validators.required);
    af = new FormControl('', Validators.required);
    // documento = new FormControl('', Validators.required);
    observacao = new FormControl('');
    motivo = new FormControl('', Validators.required);
    // bem = new FormControl('', Validators.required);
    bomba = new FormControl('', Validators.required);
    combustivel = new FormControl('');
    area = new FormControl('', Validators.required);
    funcionario = new FormControl('', Validators.required);
    local = new FormControl('');
    tanque = new FormControl('', Validators.required);
    tiposAjuste = new FormControl('', Validators.required);
    tanqueDestino = new FormControl('', Validators.required);

    private tipoEntrada: number;
    private tipoSaida: number;
    private tipoEstorno: number;
    private tipoAjuste: number;
    private tipoTransferencia: number;
    private tanquesListClone: any[] = [];
    private objectSend: MovimentacaoTanque = new MovimentacaoTanque();

    constructor(
        private _utilService: UtilService,
        private _tanqueNavigationService: TanqueNavigationService,
        private _tanqueApiService: TanqueApiService,
        private _tanqueService: TanqueService,
        private _areaApiService: AreaApiService,
        private _funcionarioApiService: FuncionarioApiService,
        private _funcionarioService: FuncionarioService,
        private _tipoAjusteApiService: TipoAjusteApiService,
        private _bombaApiService: BombaApiService,
        private _autocompleteService: AutoCompleteService,
        private _route: ActivatedRoute,
        private _fb: FormBuilder,
        private _cdRef: ChangeDetectorRef
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            data: this.data,
            quantidade: this.quantidade,
            // odometroHorimetro: this.odometroHorimetro,
            tipoLancamento: this.tipoLancamento,
            notaFiscal: this.notaFiscal,
            af: this.af,
            // documento: this.documento,
            observacao: this.observacao,
            motivo: this.motivo,
            // bem: this.bem,
            bomba: this.bomba,
            combustivel: this.combustivel,
            area: this.area,
            funcionario: this.funcionario,
            local: this.local,
            tanque: this.tanque,
            tiposAjuste: this.tiposAjuste,
            tanqueDestino: this.tanqueDestino
        });
    }

    ngOnInit() {
        this.areaQuery = this._utilService.cloneObject(areasQuery);
        this.funcionarioQuery = this._utilService.cloneObject(funcionariosQueryComPessoa);
        this.tipoLancamentosList = this._utilService.cloneObject(TiposMovimentacoesTanques);

        let tipo: any = this._tanqueService.getTipoMovimentacaoEntrada();
        this.tipoEntrada = tipo.Key;
        tipo = this._tanqueService.getTipoMovimentacaoSaida();
        this.tipoSaida = tipo.Key;
        tipo = this._tanqueService.getTipoMovimentacaoEstorno();
        this.tipoEstorno = tipo.Key;
        tipo = this._tanqueService.getTipoMovimentacaoAjuste();
        this.tipoAjuste = tipo.Key;
        tipo = this._tanqueService.getTipoMovimentacaoTransferencia();
        this.tipoTransferencia = tipo.Key;

       this._utilService.disabledFutureDates('data');

        this.getTanques();
        this.testNew();
    }

    ngAfterViewChecked() {
        this._cdRef.detectChanges();
    }

    clickGoToEstoque() {
        this.toGetOutOfHere();
    }

    clickCancel() {
        this.toGetOutOfHere();
    }

    changeTipoLancamento() {
        this.checkTipoLancamento();
    }

    changeTanque() {
        this.checkTipoLancamento();
    }

    getAreaObject(object: any) {
        this.areaObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'area', object);
    }

    getFuncionarioObject(object: any) {
        this.funcionarioObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'funcionario', object);
    }

    funcionarioTemplateResult = (function(state: any) {
        return this._funcionarioService.templateResult(state, false);
    }.bind(this));

    onSubmit(evt: any) {
        this.submitted = true;

        if (this.lancamentoObject.Key === this.tipoEntrada) {
            this._utilService.setSelectOnFormControl(this.form, 'tiposAjuste', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'motivo', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'tanqueDestino', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'area', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'bomba', {id: -1});
        } else if (this.lancamentoObject.Key === this.tipoSaida) {
            this._utilService.setSelectOnFormControl(this.form, 'tiposAjuste', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'af', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'tanqueDestino', {id: -1});
        } else if (this.lancamentoObject.Key === this.tipoEstorno) {
            this._utilService.setSelectOnFormControl(this.form, 'tiposAjuste', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'tanqueDestino', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'motivo', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'area', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'bomba', {id: -1});
        } else if (this.lancamentoObject.Key === this.tipoAjuste) {
            this._utilService.setSelectOnFormControl(this.form, 'tanqueDestino', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'motivo', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'af', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'bomba', {id: -1});
        } else if (this.lancamentoObject.Key === this.tipoTransferencia) {
            this._utilService.setSelectOnFormControl(this.form, 'motivo', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'af', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'tiposAjuste', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'bomba', {id: -1});
        }

        if (this.lancamentoObject.Key === this.tipoEstorno ||
            this.lancamentoObject.Key === this.tipoEntrada) {
            let litros: boolean = this.quantidadeLitrosAreas();
            if (!litros) {
                return;
            }
        }

        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object: any = this._utilService.cloneObject(this.formObject);

            if (this.lancamentoObject && this.lancamentoObject.Key) {
                object.tipoLancamento = this.lancamentoObject.Key;
            }

            if (this.funcionarioObject && this.funcionarioObject.id) {
                object.funcionarioId = this.funcionarioObject.id;
            } else  {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.tanqueObject && this.tanqueObject.id) {
                object.tanqueId = this.tanqueObject.id;
                object.combustivelId = this.tanqueObject.combustivelId;
                object.localId = this.tanqueObject.localId;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (object.quantidade == 0) {
                this.btnSaveDisabled = false;
                return false;
            }

            let date: any = document.getElementById('data');
            if (date.value) {
                object.data = this._utilService.convertStringToDate(date.value);
            }

            if (this.lancamentoObject.Key === this.tipoEntrada) {
                if (!this.areasList.length) {
                    this.btnSaveDisabled = false;
                    return false;
                }

                if (object.quantidade < 0) {
                    object.quantidade = object.quantidade * (-1);
                }

                delete object['motivo'];
            } else if (this.lancamentoObject.Key === this.tipoSaida) {
                if (this.bombaObject && this.bombaObject.id) {
                    object.bombaId = this.bombaObject.id;
                } else  {
                    this.btnSaveDisabled = false;
                    return false;
                }

                if (object.quantidade < 0) {
                    object.quantidade = object.quantidade * (-1);
                }

                delete object['notaFiscal'];
                delete object['af'];
            } else if (this.lancamentoObject.Key === this.tipoEstorno) {
                if (!this.areasList.length) {
                    this.btnSaveDisabled = false;
                    return false;
                }

                delete object['motivo'];
            } else if (this.lancamentoObject.Key === this.tipoAjuste) {
                if (this.tipoAjusteObject && this.tipoAjusteObject.id) {
                    object.tipoAjusteId = this.tipoAjusteObject.id;
                } else  {
                    this.btnSaveDisabled = false;
                    return false;
                }

                delete object['notaFiscal'];
                delete object['af'];
                delete object['motivo'];
            } else if (this.lancamentoObject.Key === this.tipoTransferencia) {
                if (this.tanqueDestinoObject && this.tanqueDestinoObject.id) {
                    object.tanqueDestinoId = this.tanqueDestinoObject.id;
                } else  {
                    this.btnSaveDisabled = false;
                    return false;
                }

                if (object.quantidade < 0) {
                    object.quantidade = object.quantidade * (-1);
                }

                delete object['motivo'];
                delete object['notaFiscal'];
                delete object['af'];
            }

            if (this.lancamentoObject.Key === this.tipoEntrada || this.lancamentoObject.Key === this.tipoEstorno) {
                object.Areas = this.sendAreas();
            } else {
                object.Areas = [{
                    quantidade: this.formObject.quantidade,
                    areaId: this.areaObject.id
                }];
            }

            this.objectSend = object;
            if (this.formObject.id) {
                this.onEdit(object);
            } else {
                this.onAdd(object);
            }
        }
    }

    private onAdd(object: MovimentacaoTanque) {
        this._tanqueApiService.onPostMovimentacao(object, this.onDone);
    }

    private onEdit(object: MovimentacaoTanque) {
        this._tanqueApiService.onPutMovimentacao(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this.objectSend.id = Response.id;
                this._utilService.swalMessageAddSuccess();
            }

            this.toGetOutOfHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private sendAreas() {
        let obj: any, list: MovimentacaoTanqueArea[] = [],
            x: number, lenX: number;

        for (x = 0, lenX = this.areasList.length; x < lenX; x++) {
            obj = this.areasList[x];
            if (obj.quantidade && obj.quantidade != 0 && obj.area) {
                obj.areaId = obj.area.id;
                delete obj['area'];
                list.push(obj);
            }
        }

        return list;
    }

    private testNew() {
        let id: number = +this._route.snapshot.params['id'];
        if (id) {
            this.setEditNormal(id);
        } else {
            this.setNewNormal();
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRouteFemale;
        }
    }

    private setNewNormal() {
        this.setFirstLancamento();
        this.formObject.data = this._utilService.convertDateToString(new Date());
    }

    private setEditNormal(id: number) {
        this.getMovimentacao(id);
    }

    private getMovimentacao(movimentacaoId: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;

                this.setModelToForm();
            }
        }.bind(this));

        this._tanqueApiService.onGetByMovimentacaoId(movimentacaoId, onDone);
    }

    private getTanques() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: Tanque[] = [],
                    x = 0, lenX = Response.length;

                for (x, lenX; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.tanquesList = list;
                this.tanquesListClone = this._utilService.cloneObject(list);
                this.loadingSpinnerTanques = false;

                this.setFirstTanque();
            }
        }.bind(this));

        this.loadingSpinnerTanques = true;
        this._tanqueApiService.onGetAll(onDone);
    }

    private getTiposAjustes() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: Tanque[] = [],
                    x = 0, lenX = Response.length;

                for (x, lenX; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.tipoAjustesList = list;
                this.loadingSpinnerTipoAjustes = false;

                this.setFirstTipoAjuste();
            }
        }.bind(this));

        this.loadingSpinnerTipoAjustes = true;
        this._tipoAjusteApiService.onGetAll(onDone);
    }

    private getBombas(tanqueId: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: Tanque[] = [],
                    x = 0, lenX = Response.length;

                for (x, lenX; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.bombasList = list;
                this.loadingSpinnerBombas = false;

                this.enabledBomba();
                this.setFirstBomba();
            }
        }.bind(this));

        this.loadingSpinnerBombas = true;
        this._bombaApiService.onGetByTanque(tanqueId, onDone);
    }

    private getAreasMovimentacao() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.areasList = Response;
            }
        }.bind(this));

        let query = {where:{movimentacaoId: this.formObject.id}};
        this._tanqueApiService.onGetByMovimentacaoAreaFilter(query, onDone);
    }

    private setModelToForm() {
        if (this.formObject.tipoLancamento) {
            this.setFirstLancamento();

            if (this.formObject.tipoLancamento === this.tipoEntrada ||
                this.formObject.tipoLancamento === this.tipoEstorno) {
                this.getAreasMovimentacao();
            }
        }

        if (this.formObject.data) {
            this.formObject.data = this._utilService.convertDateToString(this.formObject.data);
        }

        if (this.formObject.tanqueId) {
            this.setFirstTanque();
        }

        if (this.formObject.combustivel) {
            delete this.formObject['combustivel'];
        }

        if (this.formObject.local) {
            delete this.formObject['local'];
        }

        if (this.formObject.funcionario) {
            this.funcionarioObject = this.formObject.funcionario;
            delete this.formObject['funcionario'];

            let text = this._autocompleteService.getTextSelect2(this.funcionarioObject.pessoa, 'nome');
            let selectObject:any = {text: text, id: this.funcionarioObject.id};

            this._autocompleteService.createOptionOnSelect2(this.funcionarioSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.funcionarioSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'funcionario', this.funcionarioObject);
        }

        if (this.formObject.area) {
            this.areaObject = this.formObject.area;
            delete this.formObject['area'];

            let text = this._autocompleteService.getTextSelect2(this.areaObject, 'nome');
            let selectObject:any = {text: text, id: this.areaObject.id};

            setTimeout(function() {
                this._autocompleteService.createOptionOnSelect2(this.areaSelectId, selectObject);
                this._autocompleteService.setValueOnSelect2(selectObject.id, this.areaSelectId);
            }.bind(this));
            this._utilService.setSelectOnFormControl(this.form, 'area', this.areaObject);
        }
    }

    private setFirstTanque() {
        if (this.formObject.id) {
            let x, lenX;
            for (x = 0, lenX = this.tanquesList.length; x < lenX; x++) {
                if (this.tanquesList[x].id === this.formObject.tanqueId) {
                    this.tanqueObject = this.tanquesList[x];
                    break;
                }
            }
            delete this.formObject['tanque'];
            return;
        }

        this.tanqueObject = this.tanquesList[0];
    }

    private setFirstLancamento() {
        if (this.formObject.id) {
            let x, lenX;
            for (x = 0, lenX = this.tipoLancamentosList.length; x < lenX; x++) {
                if (this.tipoLancamentosList[x].Key === this.formObject.tipoLancamento) {
                    this.lancamentoObject = this.tipoLancamentosList[x];
                    break;
                }
            }
            return;
        }

        this.lancamentoObject = this.tipoLancamentosList[0];
    }

    private setFirstTipoAjuste() {
        if (this.formObject.id) {
            let x, lenX;
            for (x = 0, lenX = this.tipoAjustesList.length; x < lenX; x++) {
                if (this.tipoAjustesList[x].id === this.formObject.tipoAjusteId ) {
                    this.tipoAjusteObject = this.tipoAjustesList[x];
                    break;
                }
            }
            delete this.formObject['tipoAjuste'];
            return;
        }

        this.tipoAjusteObject = this.tipoAjustesList[0];
    }

    private setFirstBomba() {
        if (this.formObject.id) {
            let x, lenX;
            for (x = 0, lenX = this.bombasList.length; x < lenX; x++) {
                if (this.bombasList[x].id === this.formObject.bombaId) {
                    this.bombaObject = this.bombasList[x];
                    break;
                }
            }
            delete this.formObject['bomba'];
            return;
        }

        this.bombaObject = this.bombasList[0];
    }

    private checkTipoLancamento() {
        if (this.lancamentoObject.Key === this.tipoEntrada) {

        } else if (this.lancamentoObject.Key === this.tipoSaida) {
            this.disabledBomba();
            this.getBombas(this.tanqueObject.id);
        } else if (this.lancamentoObject.Key === this.tipoEstorno) {

        } else if (this.lancamentoObject.Key === this.tipoAjuste) {
            this.getTiposAjustes();
        } else if (this.lancamentoObject.Key === this.tipoTransferencia) {
            this.disabledTanque();
            this.setTanqueDestino();
        }
    }

    private setTanqueDestino() {
        let list: any = [],
            x: number, lenX: number;

        for (x = 0, lenX = this.tanquesListClone.length; x < lenX; x++) {
            if (this.tanquesListClone[x].id !== this.tanqueObject.id &&
                this.tanquesListClone[x].combustivelId === this.tanqueObject.combustivelId) {
                list.push(this.tanquesListClone[x]);
            }
        }

        this.tanquesDestinoList = this._utilService.cloneObject(list);
        this.enabledTanque();

        if (this.formObject.id) {
            let x, lenX;
            for (x = 0, lenX = this.tanquesDestinoList.length; x < lenX; x++) {
                if (this.tanquesDestinoList[x].id === this.formObject.tanqueDestinoId ) {
                    this.tanqueDestinoObject = this.tanquesDestinoList[x];
                    break;
                }
            }
            delete this.formObject['tanqueDestino'];
            return;
        }

        this.tanqueDestinoObject = this.tanquesDestinoList[0];
    }

    private enabledTanque() {
        if (this.tanquesDestinoList.length) {
            let element: any = this.form.controls['tanqueDestino'];
            element.enable();
        }
    }

    private disabledTanque() {
        let element: any = this.form.controls['tanqueDestino'];
        element.disable();
    }

    private enabledBomba() {
        if (this.bombasList.length) {
            let element: any = this.form.controls['bomba'];
            element.enable();
        }
    }

    private disabledBomba() {
        let element: any = this.form.controls['bomba'];
        element.disable();
    }

    private toGetOutOfHere() {
        if (this.formObject.id) {
            this._tanqueNavigationService.goToMovimentacaoDetail(this.formObject.tanqueId);
        } else {
            this._tanqueNavigationService.goToEstoque();
        }
    }

    private quantidadeLitrosAreas() {
        let soma: number = 0,
            x: number, lenX: number;

        for (x = 0, lenX = this.areasList.length; x < lenX; x++) {
           if (this.areasList[x].quantidade) {
               soma += this.areasList[x].quantidade;
           }
        }

        if (soma != this.formObject.quantidade) {
            this.showAreasMessage = true;
            return false;
        }

        this.showAreasMessage = false;
        return true;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/tanque-movimentacao-form/tanque-movimentacao-form.component.ts
 **/